import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useCallback, useEffect, useRef } from 'react';
const DEFAULT_RADIUS = 60;
export const SpiderPicker = ({ items, centerPosition, onSelect, onDismiss, radius = DEFAULT_RADIUS }) => {
    const containerRef = useRef(null);
    const handleBackdropClick = useCallback((e) => {
        if (e.target === e.currentTarget) {
            onDismiss();
        }
    }, [onDismiss]);
    useEffect(() => {
        const handleKeyDown = (e) => {
            if (e.key === 'Escape') {
                onDismiss();
            }
        };
        window.addEventListener('keydown', handleKeyDown);
        return () => window.removeEventListener('keydown', handleKeyDown);
    }, [onDismiss]);
    const getItemPosition = (index, total) => {
        const angleStep = (2 * Math.PI) / total;
        const startAngle = -Math.PI / 2;
        const angle = startAngle + index * angleStep;
        return {
            x: Math.cos(angle) * radius,
            y: Math.sin(angle) * radius
        };
    };
    return (_jsxs("div", { ref: containerRef, className: "fixed inset-0 z-50", onClick: handleBackdropClick, style: { backgroundColor: 'transparent' }, children: [_jsxs("svg", { className: "absolute pointer-events-none", style: {
                    left: centerPosition.x - radius - 40,
                    top: centerPosition.y - radius - 40,
                    width: radius * 2 + 80,
                    height: radius * 2 + 80,
                    overflow: 'visible'
                }, children: [items.map((item, index) => {
                        const pos = getItemPosition(index, items.length);
                        const svgCenter = radius + 40;
                        return (_jsx("line", { x1: svgCenter, y1: svgCenter, x2: svgCenter + pos.x, y2: svgCenter + pos.y, stroke: "rgba(255, 255, 255, 0.6)", strokeWidth: "1", strokeDasharray: "4 2" }, `line-${item.id}`));
                    }), _jsx("circle", { cx: radius + 40, cy: radius + 40, r: 4, fill: "rgba(255, 255, 255, 0.8)" })] }), items.map((item, index) => {
                const pos = getItemPosition(index, items.length);
                const itemX = centerPosition.x + pos.x;
                const itemY = centerPosition.y + pos.y;
                return (_jsxs("button", { className: "absolute flex items-center gap-2 px-2 py-1 rounded-md shadow-lg transition-transform hover:scale-110 pointer-events-auto", style: {
                        left: itemX,
                        top: itemY,
                        transform: 'translate(-50%, -50%)',
                        backgroundColor: 'var(--charcoal)',
                        border: '1px solid var(--pewter)',
                        color: 'var(--sand)',
                        minWidth: '80px',
                        maxWidth: '150px'
                    }, onClick: () => onSelect(item.id), children: [item.icon === 'placemark' ? (_jsx("div", { className: "w-4 h-4 rounded-full flex-shrink-0", style: {
                                backgroundColor: item.color,
                                border: '1px solid rgba(0,0,0,0.3)'
                            } })) : (_jsx("div", { className: "w-4 h-3 flex-shrink-0", style: {
                                backgroundColor: item.color,
                                border: '1px solid rgba(0,0,0,0.3)'
                            } })), _jsx("span", { className: "text-xs truncate", children: item.label })] }, item.id));
            })] }));
};
